module.exports = __webpack_public_path__ + "media/images/action_copy-dbaad5e7d3b46d6830771eb069c54bfd.png";